const LoadingScreen = () => {
  const LoadingComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? "Launching Najiz Express..."
      : "Launching tracktechs...";
  const LogoComponent =
    process.env.REACT_APP_EXTERNAL_ADMIN === "true"
      ? "./logo/najizFavicon.png"
      : "./img/logo-tracktech-black.svg";

  return (
    <div className="flex items-center justify-center h-screen bg-white animate-fadeIn">
      <div className="relative flex flex-col items-center space-y-10">
        {/* Glowing rotating ring */}
        <div className="absolute w-60 h-60 border-4 border-yellow-400 rounded-full animate-spin-slow blur-lg opacity-50"></div>

        {/* Pulsing and zooming logo */}
        <img
          // src="./img/logo-tracktech-black.svg"
          src={LogoComponent}
          alt="Logo"
          className="w-48 h-48 z-10 animate-logoPulse drop-shadow-[0_0_30px_rgba(255,255,0,0.9)]"
        />

        {/* Flickering yellow text */}
        <div className="h-6 overflow-hidden whitespace-nowrap border-r-2 border-yellow-400 animate-typing w-[240px]">
          <p className="text-yellow-800 text-lg font-mono tracking-widest">
            {LoadingComponent}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
